/* eslint-disable max-lines */
import React from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import {
  MusicNote,
  PhoneCallback,
  Call,
} from '@mui/icons-material';
import Grid from '@mui/material/Grid';
import { green, red } from '@mui/material/colors';
import { dayjs } from '@lba-dev/package.local-globals/dayjs';
import Tooltip from '@mui/material/Tooltip';
import { data as categories } from '@lba-dev/package.local-globals/categories';
import { formatTextToJSON } from '@lba-dev/package.local-globals/utils';
import {
  QUALIFICATION_APPEL_KEYS
} from '@lba-dev/package.local-globals/qualificationAppel';

import PriceChip from '../PriceChip';
import { getAlias } from '../../../../utils/function';

export const genDate = (date) => {
  let format = 'HH[h]mm';
  if (
    dayjs(date).isBefore(dayjs(), 'day')
  ) {
    format = 'HH[h]mm - DD/MM';
  }
  return dayjs(date).format(format);
};

export const ShowMenu = ({ array, isEmpty, classes }) => {
  let getItems =
    <Typography className={classes.historyText} variant="body1">
      {isEmpty}
    </Typography>;
  if (array.length) {
    getItems = array.reverse().map((item) =>
      typeof item.action !== 'object' &&
      <Typography
        key={`${item.date}-${item.userId}`}
        className={classes.historyText}
        variant="body1">
        {`${dayjs(item.date).format('L[ à ]HH[h]mm')} - 
        ${getAlias(item.userId)} : ${item.action}`}
      </Typography>
    );
  }
  return (
    <div className={classes.contentHistory}>
      {getItems}
    </div>
  );
};

export const ShowReason = ({ array, isEmpty, classes }) => {
  let getReason =
    <Typography className={classes.historyText} variant="body1">
      {isEmpty}
    </Typography>;
  if (array.length) {
    getReason = array.reverse().map((reason) =>
      (typeof reason.action === 'object') ?
        <Typography
          key={`${reason.date}-${reason.userId}Function`}
          className={classes.historyText} variant="body1">
          {`${isEmpty}`}
        </Typography> :
        <Typography
          key={`${reason.date}-${reason.userId}Typography`}
          className={classes.historyText} variant="body1">
          {`${reason.action}`}
        </Typography>
    )[0];
  }
  return (
    <div>
      {getReason}
    </div>
  );
};

export const returnSection = (call, kind) =>
  call.history && call.history.length
    ? call.history.filter(item => item.categorie === kind)
    : [];

export const historyTypes = [
  'Ecoute de l\'audio',
  'Appel client'
];

export const getCategorie = (call) => {
  if (typeof call.processingTextChatgpt === 'string') {
    const data = formatTextToJSON(call.processingTextChatgpt);
    const findTags = data.find((s) => (/Cat[e|é]gorie?/i).test(s.label) || (/tags?/i).test(s.label));
    if (findTags) {
      const cateogire = categories.find((l) =>
        new RegExp(l.match).test(findTags.value)
      );
      if (cateogire) {
        return (
          <Button
            style={{
              backgroundColor:
                cateogire.color[cateogire.name === 'neutre' ? '600' : '500'],
              color: 'white',
              fontSize: '11px',
              margin: '0.6%',
              minWidth: 40,
            }}
            children={cateogire.name}
          />
        );
      }
    }
  }
  return 'N/A';
};


export const findTags = (call, name) => {
  if (typeof call.processingTextChatgpt === 'string') {
    const data = formatTextToJSON(call.processingTextChatgpt);
    const findTags = data.find((s) => new RegExp(name, 'i').test(s.label));
    if (findTags) {
      return String(findTags.value);
    }
  }
  return 'N/A';
};

export const getIcons = call => {
  const price = findTags(call, 'Panier moyen');
  return (
    <Grid container spacing={1}>
      {call.onlyMusic ? (
        <Grid item>
          <Tooltip
            disableInteractive
            title="appel mis en attente"
            children={<MusicNote style={{ color: red[400] }} />}
          />
        </Grid>
      ) : ''}
      {call.agentCallBack ? (
        <Grid item>
          <Tooltip
            disableInteractive
            title="l'agent a rappelé le client"
            children={<Call style={{ color: green[400] }} />}
          />
        </Grid>
      ) : ''}
      {call.clientCallBack ? (
        <Grid item>
          <Tooltip
            disableInteractive
            title="le client a rappelé"
            children={<PhoneCallback style={{ color: green[400] }} />}
          />
        </Grid>
      ) : ''}
      {price && price !== 'N/A' ? (
        <Grid item>
          <PriceChip
            price={price}
          />
        </Grid>
      ) : ''}
    </Grid>
  );
};

export const formatTextToHTML = (text = '') => {
  const data = formatTextToJSON(text)
    .sort((a, b) => a.label.localeCompare(b.label));
  const formattedText = [];
  data.forEach(({ label, value }) => {
    value = value?.toString();
    formattedText.push(
      <>
        {label && (
          <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>
            {label} :
          </Typography>
        )}
        {value && (
          <Typography variant="subtitle2">
            {value.includes('\n') || value.includes('?')
              ? value.split(value.includes('?') ? '?' : '\n').map(
                (e) =>
                  e && (
                    <Typography key={e}>
                      {e}
                      {value.includes('?') ? ' ?' : ''}
                    </Typography>
                  )
              )
              : value}
          </Typography>
        )}
      </>
    );
  });
  return formattedText;
};


export const formatResultToJSON = (text = '') => {
  try {
    return JSON.parse(text);
  } catch (e) {
    return {};
  }
};

export const QUALIFICATION_VIDE = 'vide';

export const PRICE_QUERY = {
  [`qualificationAppel.${QUALIFICATION_APPEL_KEYS.PANIER_MOYEN}`]: {
    $regex: '[0-9]'
  },
};

export const getQualificationQuery = (qualification) => (
  qualification === QUALIFICATION_VIDE
    ? { qualificationAppel: { $exists: false } }
    : {
      [`qualificationAppel.${QUALIFICATION_APPEL_KEYS.QUALIFICATION}`]:
        qualification
    }
);

// Champs virtuels record.* de la route transformCall -> champs callRecords.
const RECORD_FIELDS = {
  id: 'callId',
  callerIdNumber: 'fromNumber',
  agent: 'toNumber',
  callStart: 'startTime',
  callAdd: 'callAdd',
  fileUrl: 'url',
  duration: 'duration',
  minDuration: 'minDuration',
};

export const toCallRecordsQuery = (query) => JSON.parse(
  JSON.stringify(query)
    .replace(/(\$?)record\.(\w+)/g, (match, prefix, field) =>
      `${prefix}${RECORD_FIELDS[field]}`)
);

const EXPORT_COLUMNS = [
  ['Date', 'callAdd'],
  ['Ligne', 'service'],
  ['Numéro agent', 'toNumber'],
  ['Numéro client', 'fromNumber'],
  ['Durée (s)', 'duration'],
  ...Object.values(QUALIFICATION_APPEL_KEYS)
    .map((key) => [key, `qualificationAppel.${key}`]),
];

export const EXPORT_HEADER = EXPORT_COLUMNS.map(([header]) => header);
export const EXPORT_FIELDS = EXPORT_COLUMNS.map(([, field]) => field);

export const getQualification = ({ qualificationAppel }) => {
  const value = qualificationAppel?.[QUALIFICATION_APPEL_KEYS.QUALIFICATION];
  if (!value) {
    return null;
  }
  return {
    value: String(value).trim(),
    motif: String(
      qualificationAppel[QUALIFICATION_APPEL_KEYS.MOTIF_NON_QUALIFICATION] || ''
    ).trim(),
    confiance: String(
      qualificationAppel[QUALIFICATION_APPEL_KEYS.CONFIANCE] || ''
    ).trim(),
  };
};

export const QualificationChip = ({ call }) => {
  const q = getQualification(call);
  if (!q) {
    return null;
  }

  const isQualified = (/Non transformé qualifié/i).test(q.value);
  const color = isQualified ? green[600] : red[400];
  const label = isQualified ? 'Qualifié' : 'Non qualifié';

  const tooltipLines = [q.value];
  if (q.motif) {
    tooltipLines.push(`Motif : ${q.motif}`);
  }
  if (q.confiance) {
    tooltipLines.push(`Confiance : ${q.confiance}`);
  }

  return (
    <Tooltip
      disableInteractive
      title={
        <span style={{ whiteSpace: 'pre-line' }}>
          {tooltipLines.join('\n')}
        </span>
      }
    >
      <span
        style={{
          display: 'inline-block',
          padding: '2px 8px',
          borderRadius: 12,
          backgroundColor: color,
          color: 'white',
          fontSize: 11,
          fontWeight: 600,
          whiteSpace: 'nowrap',
          cursor: 'default',
        }}
      >
        {label}
      </span>
    </Tooltip>
  );
};
